import {
  Circle,
  Loader2,
  CheckCircle2,
  AlertTriangle,
  HelpCircle,
  Flag,
  RotateCw,
  Copy,
  Pencil,
} from "lucide-react";
import { AppColorVariant } from "../theme/AppColorVariant";

export enum MigrationStatus {
  NotStarted = "notStarted",
  InProgress = "inProgress",
  Finished = "finished",
  Modified = "modified",
  InterruptedInitial = "interruptedInitial",
  InterruptedDelta = "interruptedDelta",
  NotFound = "notFound",
  Flagged = "flagged",
  NotFoundMarkedForRetry = "notFoundMarkedForRetry",
  SkippedDuplicate = "skippedDuplicate",
}

export const MigrationStatusMigrationEntityLabels: Record<MigrationStatus, string> = {
  [MigrationStatus.NotStarted]: "Not Started",
  [MigrationStatus.InProgress]: "In Progress",
  [MigrationStatus.Finished]: "Finished",
  [MigrationStatus.Modified]: "Modified",
  [MigrationStatus.InterruptedInitial]: "Interrupted",
  [MigrationStatus.InterruptedDelta]: "Interrupted",
  [MigrationStatus.NotFound]: "Not Found",
  [MigrationStatus.Flagged]: "Flagged",
  [MigrationStatus.NotFoundMarkedForRetry]: "Not Found (Marked For Retry)",
  [MigrationStatus.SkippedDuplicate]: "Skipped Duplicate",
};

export const MigrationStatusFileLabels: Record<MigrationStatus, string> = {
  [MigrationStatus.NotStarted]: "Not Started",
  [MigrationStatus.InProgress]: "In Progress",
  [MigrationStatus.Finished]: "Finished",
  [MigrationStatus.Modified]: "Modified",
  [MigrationStatus.InterruptedInitial]: "Interrupted Initial",
  [MigrationStatus.InterruptedDelta]: "Interrupted Delta",
  [MigrationStatus.NotFound]: "Not Found",
  [MigrationStatus.Flagged]: "Flagged",
  [MigrationStatus.NotFoundMarkedForRetry]: "Not Found (Marked For Retry)",
  [MigrationStatus.SkippedDuplicate]: "Skipped Duplicate",
};

export const MigrationStatusColors: Record<MigrationStatus, AppColorVariant> = {
  [MigrationStatus.NotStarted]: "neutral",
  [MigrationStatus.InProgress]: "warning",
  [MigrationStatus.Finished]: "success",
  [MigrationStatus.Modified]: "lime",
  [MigrationStatus.InterruptedInitial]: "danger",
  [MigrationStatus.InterruptedDelta]: "pink",
  [MigrationStatus.NotFound]: "warning",
  [MigrationStatus.Flagged]: "primary",
  [MigrationStatus.NotFoundMarkedForRetry]: "yellow",
  [MigrationStatus.SkippedDuplicate]: "lavender",
};

export const MigrationStatusIcons: Record<MigrationStatus, React.ElementType> = {
  [MigrationStatus.NotStarted]: Circle,
  [MigrationStatus.InProgress]: Loader2,
  [MigrationStatus.Finished]: CheckCircle2,
  [MigrationStatus.Modified]: Pencil,
  [MigrationStatus.InterruptedInitial]: AlertTriangle,
  [MigrationStatus.InterruptedDelta]: AlertTriangle,
  [MigrationStatus.NotFound]: HelpCircle,
  [MigrationStatus.Flagged]: Flag,
  [MigrationStatus.NotFoundMarkedForRetry]: RotateCw,
  [MigrationStatus.SkippedDuplicate]: Copy,
};